import { local } from 'wix-storage';
import wixWindow from 'wix-window';

$w.onReady(function () {
    //TODO: write your page related code here...
    const today = new Date();
    $w("#copyright").text = "© " + today.getFullYear().toString() + ", TOBIAS AND THE ANGEL";
    // © My Company
    christmasShow();
});

function christmasShow() {

    const xmasKey = "xmas2021";
    let exp = new Date('26 Dec 2021');
    const today = new Date();
    if (today < exp) {
        let xmas = local.getItem(xmasKey);
        if (!xmas) {
            wixWindow.openLightbox('christmasShow');
            local.setItem(xmasKey, 'true');
        }
    }
}